import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReportIssueInputs } from '../../models/reportIssue.model';
import { ReportIssueService } from '../../services/report-issue.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';


@Component({
  selector: 'app-report-issue-popup',
  templateUrl: './report-issue-popup.component.html',
  styleUrls: ['./report-issue-popup.component.css']
})
export class ReportIssuePopupComponent implements OnInit {


  headerTitle: string = "Report An Issue";
  report: ReportIssueInputs = {};
  files: any[] = []; // Array to store file details
  uploadSizeExceed: boolean = false;


  @Input() ReportInput!: ReportIssueInputs;
  @Input() SelectedModule: string = '';
  @Input() SelectionSummary: string = '';
  @Output() closePopup: EventEmitter<boolean> = new EventEmitter();

  constructor(private reportService: ReportIssueService, public _configService: SnapshotService ) {
    let clientStudy = this.reportService.clientStudy;
    this.report.client_name = clientStudy.clientName;
    this.report.study_name = clientStudy.StudyName;
    this.report.snapshot_name = clientStudy.SubStudy;
    this.report.module_name = clientStudy.ModuleName;

  }

  ngOnInit() {
    //  this.report.selectionSummary = this._configService.selectionSummaryTextTitle.split('||')
    //  .find(a => a.trim().startsWith("Selections:"))
    //  ?.replace("Selections: ", "").trim() ?? "";
    if(this.SelectedModule=='CROSSTAB' || this.SelectedModule=='BRAND ANALYSIS'){
      this.report.selectionSummary = this.SelectionSummary;
      //let summarytext = this.SelectionSummary.replace(/<[^>]*>/g, '');
    }
    else
      this.report.selectionSummary = this._configService.selectionSummaryTextTitle;
  }

  close(): void {
    this.closePopup.emit();
  }

  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const selectedFiles = Array.from(input.files);

      // Initialize report.files if it's null/undefined
      this.report.files = this.report.files || [];

      // Calculate the total size of currently selected and previously added files
      let totalSize = (this.report.files || []).reduce((sum, file) => sum + file.size, 0);

      selectedFiles.forEach((file) => {
        if (totalSize + file.size <= 10 * 1024 * 1024) {
          totalSize += file.size;
        } else {
          this.uploadSizeExceed = true;
          return;
        }
      });

      if (!this.uploadSizeExceed) {
        // Check if there are already files and append new files
        if (this.report.files && this.report.files.length > 0) {
          this.report.files = this.report.files.concat(selectedFiles);
        } else {
          this.report.files = selectedFiles;
        }
        this.files = this.report.files;
      }
    }
  }




  // Submit Report
  submitReport() {
    debugger;
    console.log('Report Submitted:', this.report);
    this.reportService.saveReportIssue(this.report).subscribe((response) => {
      alert('Report Submitted Successfully!');
    });

  }



  removeFile(fileToRemove: { name: string; size: number }): void {
    debugger;
    this.files = this.files.filter(file => file !== fileToRemove);
    this.report.files = this.report.files?.filter(file => file.name !== fileToRemove.name);
  }
}
